import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// @TODO: lint rule
/* eslint-disable boundaries/element-types */
import { InputContainer } from '@_widgets/user';

import { useHTMLParse } from '@_shared/hooks';
import { RightChevronIcon } from '@_shared/icons';
import { Button } from '@_shared/ui/Button';
import { Typography } from '@_shared/ui/Typography';

import * as S from './EmailSlide.style';

function isEmailValid(email: string) {
	const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

	return emailRegex.test(email);
}

export function EmailSlide({
	onNext,
	setEmail: setResultDataEmail,
	nickname,
}: {
	onNext: () => void;
	setEmail: (email: string) => void;
	nickname: string;
}) {
	const [searchParams] = useSearchParams();
	const initialEmail = searchParams.get('email') ?? '';

	const [inputEmail, setEmail] = useState<string>(initialEmail);
	const [isButtonClicked, setIsButtonClicked] = useState<boolean>(false);
	const [error, setError] = useState<string | undefined>();

	const parsedError = useHTMLParse(error ?? '');

	useEffect(() => {
		if (isButtonClicked) {
			setError(isEmailValid(inputEmail) ? undefined : '이메일 형식을 확인해주세요');
		}
	}, [inputEmail, isButtonClicked]);

	const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(e.target.value);
	};

	const handleNext = () => {
		setIsButtonClicked(true);
		if (isEmailValid(inputEmail)) {
			setResultDataEmail(inputEmail);
			onNext();
		} else {
			setError('이메일 형식을 확인해주세요');
		}
	};

	return (
		<S.SlideContainer>
			<S.TermsSlide>
				<Typography type="headline-small" color="font-primary">
					{nickname}
					님의
					<br />
					이메일 주소를 알려주세요!
				</Typography>

				<InputContainer.Container>
					<Typography type="title-small" color="font-tertiary">
						이메일
					</Typography>
					<InputContainer.Input
						type="email"
						defaultValue={initialEmail}
						onChange={handleEmailChange}
						aria-invalid={!!error}
						aria-describedby={error ? 'email-error' : undefined}
					/>
					{error && (
						<InputContainer.Explain>
							<Typography type="label-medium" color="orange-primary">
								{parsedError}
							</Typography>
						</InputContainer.Explain>
					)}
				</InputContainer.Container>
			</S.TermsSlide>

			<S.BottomButtonContainer>
				<Button
					bgColor={inputEmail ? 'orange-primary' : 'warmgray-300'}
					fullWidth
					disabled={!inputEmail}
					onClick={handleNext}
					aria-label="다음 단계로 이동"
				>
					<Typography type="title-large" color="white-primary">
						다음
					</Typography>
				</Button>
				<S.SkipText
					onClick={() => {
						onNext();
					}}
				>
					<Typography type="label-large">건너뛰기</Typography>
					<RightChevronIcon />
				</S.SkipText>
			</S.BottomButtonContainer>
		</S.SlideContainer>
	);
}
